import * as React from "react";
import './importantNotes.scss';
import {option, Option} from "ts-option";
import PartnerBrand from "../../model/partnerBrand/PartnerBrand";
import DateUtils from "../../utils/DateUtils";
import {AuthenticatedEntityTypeEnum} from "../../model/user/AuthenticatedEntity";
import {getUser} from "../../store/view/user";
import TextUtils from "../../utils/TextUtils";

const sanitizeHtml = require("sanitize-html");

interface Props {
	partnerBrand: Option<PartnerBrand>
}

export const ImportantNotes: React.SFC<Props> = (props) => {
	if (props.partnerBrand.flatMap(pb => pb.noteImportant).isDefined) {
		const noteAuthor = props.partnerBrand.flatMap(
			pb => pb.noteImportantAuthor.flatMap(c => c.type === AuthenticatedEntityTypeEnum.User ?
				getUser(c.id).map(user => user.getDisplayName()) :
				option(c.type))).orNull;
		const noteUpdated = props.partnerBrand.flatMap(pb => pb.noteImportantUpdatedDateTime).map(
			date => date.format(DateUtils.DATE_TIME_FORMAT)).orNull;
		const html = sanitizeHtml(TextUtils.createTextLinks(props.partnerBrand.flatMap(pb => pb.noteImportant).orNull), {
			allowedTags: ["a"],
			allowedAttributes: {
				"a": ["href", "class", "target"]
			}
		});
		return (
			<div className="notes-wrapper">
				<div className="dot-wrapper">
					<div className="dot" />
				</div>
				<div className="content-wrapper">
					<h4 className="title">
						Important partner notes
					</h4>
					<div className="content">
						<span className={"pre-line"} dangerouslySetInnerHTML={{__html: html}}/>
					</div>
					<div className="footer-details">
						Last updated by {noteAuthor} at {noteUpdated}
					</div>
				</div>
			</div>
		)
	}
	else {
		return null;
	}
};